import { Component, DestroyRef, inject, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppsService } from '@apps/apps.service';
import { AuthenticationService } from '@services/authentication.service';
import { ResponsiveService } from '@services/responsive.service';
import { UserService } from '@services/user.service';
import { map, shareReplay, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'novus-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css'],
  standalone: false
})
export class NavMenuComponent {
  private destroyRef = inject(DestroyRef);
  private modules = inject(AppsService);
  clickedItem = output();
  mobile$ = inject(ResponsiveService).isMobileEvent;
  authenticationService = inject(AuthenticationService);
  userService = inject(UserService);
  impersonatingEmail = '';
  allowedApps$ = this.authenticationService.user.pipe(
    switchMap(() => this.modules.getApps()),
    map(a => a.map(app => ({...app, icon: this.iconForApp(app.name)}))),
    tap(() => window.dispatchEvent(new Event('resize'))),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  constructor(){
    this.userService.impersonatedUser$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((user) => {
      this.impersonatingEmail = user?.email ?? '';
    });
  }

  stopImpersonating() {
    this.authenticationService.returnFromImpersonation()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({ error: () => undefined });
  }

  private iconForApp(app: string) {
    switch (app) {
      case 'Projects':
        return 'fa-solid fa-diagram-project';
      case 'Organizations':
        return 'fa-solid fa-landmark-flag';
      case 'DeltaCubes':
        return 'fa-solid fa-cubes';
      default:
        return '';
    }
  }
}
